'use client';

import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { Button } from '@/lib/ui-kit/button';
import { Icon } from '@/lib/ui-kit/icons';
import { cn } from '@/lib/ui-kit/utils';

interface BackButtonProps {
  className?: string;
  variant?: 'text' | 'outlined' | 'ghost' | 'contained';
  size?: 'sm' | 'md' | 'lg' | 'default' | 'icon';
  children?: React.ReactNode;
  fallbackHref?: string;
}

export function BackButton({
  className,
  variant = 'text',
  size = 'default',
  children,
  fallbackHref = '/',
}: BackButtonProps) {
  const t = useTranslations('common');
  const router = useRouter();

  const handleBack = () => {
    if (window.history.length > 1) {
      router.back();
    } else {
      router.push(fallbackHref);
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleBack}
      className={cn('w-fit gap-2', className)}
    >
      {children || (
        <>
          <Icon name="ChevronRight" size={16} className="rotate-180" />
          {t('goBack')}
        </>
      )}
    </Button>
  );
}
